import React, { useCallback, useMemo } from "react";
import { Button, IconButton } from "@mui/material";
import classNames from "classnames";
import { useSelector } from "react-redux";

import {
  Add,
  Info as EditIcon,
  Info,
  Person,
  OpenInNew as OpenInNewIcon,
  Edit,
  Topic,
} from "@mui/icons-material";
import { Tooltip,Typography } from "@mui/material";
import { InfoOutlined as InfoIcon } from "@mui/icons-material";
import styles from "./Style.module.css";
import DataTables from "../../Datatables/Datatable.table";
import Constants from "../../config/constants";
import FilterComponent from "../../components/Filter/Filter.component";
import useAppUsersListHook from "./AppUsersListHook";
//import useUnitCreateHook from "./Create/UnitCreate.hook";
import capitalizeFirstLetter from "../../hooks/CommonFunction";
import { OutlineButton, PrimaryButton } from "../../components/Buttons/PrimaryButton";
import StatusPill from "../../components/Status/StatusPill.component";
import SidePanelComponent from "../../components/SidePanel/SidePanel.component";
import city from "./../../assets/CRMAssets/ic_city@2x.png";
import ShadowBox from "../../components/ShadowBox/ShadowBox";
import { ListActionComponent } from "../../components/CustomListHeader/CustomListHeader";
import { useNavigate } from "react-router-dom";
import useRoles from "../../hooks/RoleHook";
import CircularProgress from "@mui/material/CircularProgress";
const AppUsersList = (props) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    isSidePanel,
    handleSideToggle,
    handlePageChange,
    handleEdit,
    handleEditSidePannel,
    handleFilterDataChange,
    handleSearchValueChange,
    handleProfile,
    handleDetail,
    configFilter,
    handleCreate,
    handleExport,
    editData,
    isSubmitting
  } = useAppUsersListHook({});
  const editDataId = editData ? editData.id : null;
  const {canRead} = useRoles(Constants.MODULES.APP_USERS);
  const {
    present,
    all: allData,
    currentPage,
    is_fetching: isFetching,
  } = useSelector((state) => state.appusers);

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
      

        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>{`${capitalizeFirstLetter(user?.first_name ??" N/A")} ${capitalizeFirstLetter(user?.last_name ?? "")}`} </div>
          
        </div>
      </div>
    );
  }, []);
 
  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"ACTIVE"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"INACTIVE"} color={"high"} />;
    }
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "first_name",
        label: "Name ",
        sortable: true,
         render: (value, all) => <div>{renderFirstCell(all)}</div>,
      },

     
      {
        key: "full_contact",
        label: "Phone Number",
        sortable: false,
        render: (temp, all) => <div>+{all?.full_contact ?? "N/A"}</div>,
      },
      
      {
        key: "email",
        label: "Email",
        sortable: false,
        render: (temp, all) => <div>{all?.email ?? "N/A"}</div>,
      },
      
      // {
      //   key: "programCount",
      //   label: "Program Enrolled",
      //   sortable: false,
      //   render: (temp, all) => <div>{all?.programCount ?? "N/A"}</div>,
      // },
      {
        key: "lastLoginText",
        label: "Last Login",
        sortable: false,
        render: (temp, all) => <div>{all?.lastLoginText}</div>,
      },
      {
        key: "status",
        label: (
          <span className={styles.info}>
            Status{" "}
            <Tooltip title={
          <>
            User account will be marked
            <br />
            as inactive if they remain
            <br/>
             unlogged for 30 days
          </>
        }aria-label="info" placement="right" className={styles.infoTip}>
              <InfoIcon fontSize="small" />
            </Tooltip>
          </span>
        ),
        sortable: false,
        render: (temp, all) => <div><>{renderStatus(all.status)} </></div>,
      },
    //   ...(canRead ?[{
    //     key: "user_id",
    //     label: "Action",
    //     render: (temp, all) => (
    //       <div className={styles.actionButton}>
    //         <IconButton
    //   disableRipple="false"
    //   onClick={() => {
        
    //      handleDetail(all);
    //   }}
    // >
    //   <Info
    //     fontSize={"small"}
       
    //   />
    // </IconButton>
           
            
    //       </div>
    //     ),
    //   },
    // ]:[]),
    ],
    [
      renderFirstCell,
      renderStatus,
      handleEdit,
      handleProfile,

      handleEditSidePannel,
    ]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
      // clickableRow: handleEditSidePannel,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: present,
      count: allData.length,
      page: currentPage,
      draggable: true,
    };

    return { datatableFunctions, datatable };
  }, [
    allData,
    tableStructure,
    handleSortOrderChange,
    handlePageChange,

    handleRowSize,
    present,
    currentPage,
 
  ]);
  const panelTitle = editData ? "Edit State" : "Add State";
  return (
    <div>
      <ShadowBox className={styles.unit}>
        <div className={styles.headerContainer}>
          <Typography
            variant={"title"}
            color={"text.primary"}
            className={styles.title}
          >
            App User List
          </Typography>
          {/* <OutlineButton
         
          >
           DOWNLOAD
          </OutlineButton> */}
          <PrimaryButton
          onClick={handleExport}
          disabled={isSubmitting}
        >
          {isSubmitting ? (  <CircularProgress size={24} color={"primary"} /> ) : ("EXPORT")}
        </PrimaryButton>
          <SidePanelComponent
            handleToggle={handleSideToggle}
            title={panelTitle}
            open={isSidePanel}
            side={"right"}
          >
            
          </SidePanelComponent>
        </div>
        <div>
          <FilterComponent
            is_progress={isFetching}
            filters={configFilter}
            handleSearchValueChange={handleSearchValueChange}
            handleFilterDataChange={handleFilterDataChange}
            placeholder="Search by user name"
          />
          <div>
            <br />
            <div style={{ width: "100%" }}>
              <DataTables
                {...tableData.datatable}
                {...tableData.datatableFunctions}
              />
            </div>
          </div>
        </div>
      </ShadowBox>
    </div>
  );
};

export default AppUsersList;
